import { useState, useEffect } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Input, Flex, Button, Text, Box } from '@chakra-ui/react';
import { FaCopy, FaClipboardCheck, FaPlus } from 'react-icons/fa';

const ModalRespostasProntas = ({ isOpen, onClose, respostas, onSelecionarResposta = null }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [copiedId, setCopiedId] = useState(null);

    const respostasFiltradas = searchTerm
        ? respostas.filter(r => r.texto.toLowerCase().includes(searchTerm.toLowerCase()))
        : respostas;

    useEffect(() => {
        if (!isOpen) setSearchTerm("");
    }, [isOpen]);
    
    const handleCopy = (texto, id) => {
        navigator.clipboard.writeText(texto);
        setCopiedId(id);
        setTimeout(() => setCopiedId(null), 1500);
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size={"xl"} scrollBehavior="inside">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Respostas Prontas</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Input
                        placeholder="Buscar resposta..."
                        mb={4}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <Box maxHeight="60vh" overflowY="auto">
                        {respostasFiltradas.map((resposta) => (
                            <Flex key={resposta.id} align="start" mb={4} gap={2}>
                                {onSelecionarResposta && (
                                    <Button
                                        size="sm"
                                        variant="ghost"
                                        colorScheme="teal"
                                        onClick={() => onSelecionarResposta(resposta.texto)}
                                        title="Inserir resposta na pergunta atual"
                                        flexShrink={0}
                                    >
                                        <FaPlus fontSize="1rem" />
                                    </Button>
                                )}
                                <Button
                                    size="sm"
                                    variant="ghost"
                                    onClick={() => handleCopy(resposta.texto, resposta.id)}
                                    title="Copiar para área de transferência"
                                    flexShrink={0}
                                >
                                    {copiedId === resposta.id ? <FaClipboardCheck fontSize="1rem" color="green" /> : <FaCopy fontSize="1rem" />}
                                </Button>
                                <Text fontSize="sm" cursor="default" pt={1}>
                                    {resposta.texto}
                                </Text>
                            </Flex>
                        ))}
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default ModalRespostasProntas;